// src/components/Footer.js
import React from 'react';
import "./baseStyles.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="/terms" target="_blank" rel="noopener noreferrer">Terms</a>
        <span>|</span>
        <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
        <span>|</span>
        <a href="/contact" target="_blank" rel="noopener noreferrer">Contact</a>
      </div>
      <div className="footer-copy">
        © {new Date().getFullYear()} MyDailyReminders, LLC
      </div>
    </footer>
  );
};

export default Footer;
